import React from 'react'
import dayjs from 'dayjs'

import CreatorCardOnHover from 'components/CreatorCardOnHover'
import ReasoningVideoText from 'components/ReasoningVideoText'
import { T } from 'lib/tolgee'
import { numberUtils } from 'utils'
import './index.scss'

const TOLGEE_PREFIX = 'ReasoningCreatorVideo'

export default function ReasoningCreatorVideo({
  creator,
  creatorId,
  provider,
  publishedAt,
  isTrendingTag,
  reasoning,
  likes,
  videoTitle,
}) {
  return (
    <div className="ReasoningCreatorVideo">
      <div className="ReasoningCreatorVideo-text">
        <span>
          <T keyName={`${TOLGEE_PREFIX}-publishedText`}>Published by </T>
        </span>
        <CreatorCardOnHover
          videoTitle={videoTitle}
          type={creator?.__typename}
          title={creator?.title}
          id={creatorId}
          provider={provider}
          groupId={creator?.groupId}
        />{' '}
        {isTrendingTag ? (
          <span>
            <T
              keyName={`${TOLGEE_PREFIX}-dateText`}
              parameters={{
                date: dayjs(publishedAt).from(dayjs()),
                period: dayjs().diff(dayjs(publishedAt), 'day') <= 1 ? 'yesterday' : 'this week',
                likesValue: numberUtils.format(likes, 1) ?? '--',
                strong: <strong />,
              }}
            >
              {
                '{date}, this is the most liked video {period, select, yesterday {since yesterday} other {this week}} with <strong>{likesValue} likes</strong>'
              }
            </T>
          </span>
        ) : (
          <ReasoningVideoText reasoning={reasoning} publishedAt={publishedAt} />
        )}
      </div>
    </div>
  )
}
